import { defineComponent, computed } from '@vue/composition-api';
export default defineComponent({
    props: {
        data: {}
    },
    setup($p) {
        let ty = computed(() => $p.data.cy - 3 + '%');
        let cx = computed(() => $p.data.cx + '%');
        let cy = computed(() => $p.data.cy + '%');
        let x1 = computed(() => $p.data.x1 + '%');
        let y1 = computed(() => $p.data.y1 + '%');
        let x2 = computed(() => $p.data.x2 + '%');
        let y2 = computed(() => $p.data.y2 + '%');
        let name = computed(() => $p.data.name);
        let unit = computed(() => $p.data.unit);
        let value = computed(() => $p.data.value);
        let color = computed(() => $p.data.color);
        return {
            ty,
            cx,
            cy,
            x1,
            y1,
            x2,
            y2,
            name,
            unit,
            value,
            color
        };
    }
});
